module.exports = __webpack_public_path__ + "media/images/writer/monitor/txt-monitor@3x-a4f22c38f05d8a0ea57ee41011fb007a.png";